import { useCallback } from 'react';

import { ActionBar, ButtonVariant, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys, visitTranslationKeys } from '../../translations';

type GoToPatientHistoryActionProps = { patientId: number };

export const GoToPatientHistoryAction = (props: GoToPatientHistoryActionProps): JSX.Element | null => {
   const push = useHistoryPushWithBackAction(true);

   const handleClick = useCallback(() => {
      push(
         visitPaths.getVisitHistoryPath({
            params: { patientId: props.patientId },
            searchParams: {},
         }),
         { label: visitTranslationKeys.goBackToAppointmentsList }
      );
   }, [push, props.patientId]);

   return protectFeature(
      'searchingMedicalData',
      <ActionBar.PrimaryButton
         testId={'patientHistory'}
         variant={ButtonVariant.SECONDARY}
         label={appointmentsTranslationKeys.patientHistory}
         onClick={handleClick}
      />,
      null
   );
};
